export const code: {
  [page: string]: { [snippetKey: string]: { [language: string]: string } };
} = {
  auth: {
    signatureCode: {
      php: `
    $app_id = 'your_app_id';
    $app_key = 'your_app_key';
    $app_secret = 'your_app_secret';
    $payload = {
        'date': '12345',
    };
    $timestamp = time();
    $nonce = '12345'; // random string it should be unique

    $full_payload = $app_id . '|' . $payload . '|' . $app_secret . '|' . $timestamp . '|' . $nonce;
    $signature = hash('sha256', $full_payload, $app_key);

    return response()->json([
        'signature' => $signature,
        'timestamp' => $timestamp,
        'nonce' => $nonce
    ]);
    `,
      javascript: `
    const crypto = require('crypto');

    const appId = 'your_app_id';
    const appKey = 'your_app_key';
    const appSecret = 'your_app_secret';
    const payload = {
        date: '12345',
    };
    const timestamp = Math.floor(Date.now() / 1000); // Current UNIX timestamp
    const nonce = '12345'; // Random string, should be unique

    const fullPayload = appId|JSON.stringify(payload)|appSecret|timestamp|nonce;
    const signature = crypto
        .createHmac('sha256', appKey)
        .update(fullPayload)
        .digest('hex');

    console.log({
        signature: signature,
        timestamp: timestamp,
        nonce: nonce
    });
    `,
      python: `
    import hashlib
    import hmac
    import json
    import time

    app_id = 'your_app_id'
    app_key = 'your_app_key'
    app_secret = 'your_app_secret'
    payload = {
        'date': '12345',
    }
    timestamp = int(time.time())  # Current UNIX timestamp
    nonce = '12345'  # Random string, should be unique

    full_payload = f"{app_id}|{json.dumps(payload)}|{app_secret}|{timestamp}|{nonce}"
    signature = hmac.new(
        key=app_key.encode(),
        msg=full_payload.encode(),
        digestmod=hashlib.sha256
    ).hexdigest()

    print({
        'signature': signature,
        'timestamp': timestamp,
        'nonce': nonce
    })
    `,
    },
    requestProcess: {
      php: `
    <?php

    $curl = curl_init();

    curl_setopt_array($curl, array(
        CURLOPT_URL => 'https://panel.whatsup2u.com/api/merchant/v1/verity-signature',
        CURLOPT_RETURNTRANSFER => true,
        CURLOPT_ENCODING => '',
        CURLOPT_MAXREDIRS => 10,
        CURLOPT_TIMEOUT => 0,
        CURLOPT_FOLLOWLOCATION => true,
        CURLOPT_HTTP_VERSION => CURL_HTTP_VERSION_1_1,
        CURLOPT_CUSTOMREQUEST => 'POST',
        CURLOPT_POSTFIELDS =>'{
            "name": "Ali",
            "age": 10,
            "address": "Jalan Ali"
        }', // example payload
        CURLOPT_HTTPHEADER => array(
            'X-App-Id: {{X-App-Id}}',
            'X-App-Signature: {{X-App-Signature}}',
            'X-Timestamp: {{X-App-Timestamp}}',
            'X-Nonce: {{X-Nonce}}',
            'Content-Type: application/json'
        ),
    ));

    $response = curl_exec($curl);

    curl_close($curl);
    echo $response;
        `,
      javascript: `
    const axios = require('axios');
    let data = JSON.stringify({
    "name": "Ali",
    "age": 10,
    "address": "Jalan Ali"
    }); // example payload

    let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: 'https://panel.whatsup2u.com/api/merchant/v1/verity-signature',
        headers: { 
            'X-App-Id': '{{X-App-Id}}', 
            'X-App-Signature': '{{X-App-Signature}}', 
            'X-Timestamp': '{{X-App-Timestamp}}', 
            'X-Nonce': '{{X-Nonce}}', 
            'Content-Type': 'application/json'
        },
        data : data
    };

    axios.request(config).then((response) => {
        console.log(JSON.stringify(response.data));
    }).catch((error) => {
        console.log(error);
    });
      `,
      python: `
    import requests
    import json

    url = "https://panel.whatsup2u.com/api/merchant/v1/verity-signature"

    payload = json.dumps({
        "name": "Ali",
        "age": 10,
        "address": "Jalan Ali"
    }) # example payload
    headers = {
        'X-App-Id': '{{X-App-Id}}',
        'X-App-Signature': '{{X-App-Signature}}',
        'X-Timestamp': '{{X-App-Timestamp}}',
        'X-Nonce': '{{X-Nonce}}',
        'Content-Type': 'application/json'
    }

    response = requests.request("POST", url, headers=headers, data=payload)

    print(response.text)
      `,
    },
  },
  error: {
    index: {
      php: `
        $error = new Error();
        $error->handle(404);
        `,
      javascript: `
        const error = new Error();
        error.handle(404);
        `,
      python: `
        error = Error()
        error.handle(404)
        `,
    },
  },
};
